import '../../styles/_support-panel.scss';

import React, { useMemo, useState } from 'react';

import { useClearCmsCacheMutation } from '../../datasource/mutations/cmsCache';
import { useGetDebugDataQuery } from '../../datasource/queries/debug';
import { useAppSelector } from '../../hooks';
import Button from '../Button/Button';

export const Debug = () => {

    const launchDetails = useAppSelector((state) => state.player.launchDetails);

    const { data: debugData } = useGetDebugDataQuery();

    const str = useMemo(() => {
        return JSON.stringify(launchDetails, null, 4);
    }, [launchDetails]);

    const [clearCmsCache, { isLoading, isSuccess }] = useClearCmsCacheMutation();

    const onClickClearCacheButton = async () => {
        await clearCmsCache();
    };

    const [showLaunchDetails, setShowLaunchDetails] = useState(false);
    const [showHeadlessContent, setShowHeadlessContent] = useState(false);

    return (
        <div className="debug">
            <h3 className="support-panel__sub-panel__title">Debug</h3>
            <Button 
                action={onClickClearCacheButton}
                buttonClass={`mb-4 sticky-button ${isSuccess ? 'sticky-button--success' : ''}`}
                isLoading={isLoading}
                label={isSuccess ? 'CMS cache cleared, please refresh' : 'Click to clear CMS cache'}
            />
            <p><span className='text--grey'>Base content url:</span> <span> {debugData?.contentBaseUrl}</span></p>
            
            <p><span className='text--grey'>PLIEDU API Client Url:</span> <span>{debugData?.pliEduApiClientBaseUrl}</span></p>
            
            <h4 className="paragraph-1--medium">headless/watch contentArea JSON:</h4>
            <button onClick={() => setShowHeadlessContent(!showHeadlessContent)}>Click to show/hide headless/watch json</button>
            <button onClick={() => navigator.clipboard.writeText(debugData?.topHeadlessPageJson ?? '')}>Click to copy headless/watch json</button>

            {showHeadlessContent && <pre className="support-panel__text paragraph-1">
                {debugData?.topHeadlessPageJson}
            </pre>}



            <h4 className="paragraph-1--medium">Launch Details:</h4>
            <button onClick={() => setShowLaunchDetails(!showLaunchDetails)}>Click to show/hide launch details json</button>
            {showLaunchDetails && <pre className="support-panel__text paragraph-1">
                {str}
            </pre>}
        </div>
    );
};

export default Debug;
